import { call, put, takeEvery, all } from 'redux-saga/effects'

import preferredLanesTypes from './preferredLanesTypes'
import * as preferredLanesActions from './preferredLanesActions'
import PreferredLanesServices from '../../services/PreferredLaneService/PreferredLanesService'
import notificationActions from '../notifications/notificationActions'

export function * getPreferredLanes () {
  try {
    const { data } = yield call(PreferredLanesServices.fetchPreferredLanes)
    yield put(preferredLanesActions.getPreferredLanesSuccess(data))
  } catch ({ message }) {
    yield put(preferredLanesActions.getPreferredLanesFailure(message))
  }
}

export function * addPreferredLane ({ payload, callback }) {
  try {
    const { data } = yield call(PreferredLanesServices.addPreferredLane, payload)
    yield put(notificationActions.SendToast({ message: 'Lane added succesfully', type: 'success' }))
    yield put(preferredLanesActions.addPreferredLaneSuccess({ ...data, ...payload }))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(preferredLanesActions.addPreferredLaneFailure(message))
  }
}

export function * updatePreferredLane ({ payload, callback }) {
  try {
    yield call(PreferredLanesServices.updatePreferredLane, payload)
    yield put(notificationActions.SendToast({ message: 'Lane edited succesfully', type: 'success' }))
    yield put(preferredLanesActions.updatePreferredLaneSuccess(payload))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(preferredLanesActions.updatePreferredLaneFailure(message))
  }
}

export function * deletePreferredLane ({ payload, callback }) {
  try {
    yield call(PreferredLanesServices.deletePreferredLane, payload)
    yield put(notificationActions.SendToast({ message: 'Lane deleted succesfully', type: 'success' }))
    yield put(preferredLanesActions.deletePreferredLaneSuccess(payload))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(preferredLanesActions.deletePreferredLaneFailure(message))
  }
}

export function * onGetPreferredLanes () {
  yield takeEvery(preferredLanesTypes.GET_PREFERRED_LANES, getPreferredLanes)
}

export function * onAddPreferredLane () {
  yield takeEvery(preferredLanesTypes.ADD_PREFERRED_LANE, addPreferredLane)
}

export function * onUpdatePreferredLane () {
  yield takeEvery(preferredLanesTypes.UPDATE_PREFERRED_LANE, updatePreferredLane)
}

export function * onDeletePreferredLane () {
  yield takeEvery(preferredLanesTypes.DELETE_PREFERRED_LANE, deletePreferredLane)
}

export function * preferredLanesSaga () {
  yield all([
    call(onGetPreferredLanes),
    call(onAddPreferredLane),
    call(onUpdatePreferredLane),
    call(onDeletePreferredLane)
  ])
}
